<template>
  <div>
    <v-slider
      v-model="selectedRadius"
      :thumb-size="24"
      thumb-label="always"
      thumb-color="primary"
      track-color="grey lighten-2"
      track-fill-color="grey lighten-2"
      :label="radiusLabel"
      :max="radiusMax"
      :min="radiusMin"
      @end="handleOnEndRadius"
      @mouseup="handleOnEndRadius"
      class="mt-4 asset-radius"
    >
      <template v-slot:thumb-label="props">
        <span class="application-heading">{{ props.value }}</span>
      </template>
    </v-slider>

    <div class="assets-container">
      <v-btn text color="primary" class="mr-3" @click="openModal"
        >Select assets</v-btn
      >
      <span
        v-if="
          !notification.formatted.params.managedAssets ||
          notification.formatted.params.managedAssets.length === 0
        "
      >
        No assets selected
      </span>
      <span
        v-if="
          notification.formatted.params.managedAssets &&
          notification.formatted.params.managedAssets.length > 0
        "
      >
        {{ notification.formatted.params.managedAssets.length }} assets selected
      </span>
    </div>

    <v-dialog v-model="modal" persistent :width="1200">
      <v-card>
        <v-card-title class="mb-0 pb-0"> Select Assets </v-card-title>

        <v-container class="my-0 py-0">
          <v-row>
            <v-col class="my-0 py-0">
              <AssetsList
                :selecting="selecting"
                :alert-id="notificationId"
                :filters-selected="selectedFilters"
                @change-filter="handleChangeFilter"
              ></AssetsList>
            </v-col>
          </v-row>
        </v-container>

        <v-card-actions>
          <v-btn
            color="primary"
            class="mr-2"
            :disabled="assetsSelected.length < 1"
            @click="handleClickSelect"
            >Use Selected Assets ({{ assetsSelected.length }})
          </v-btn>

          <v-btn text @click="handleClickCancel">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import lodashGet from "lodash/get";
import lodashCloneDeep from "lodash/cloneDeep";

import {
  MODULE_PREFIX_NOTIFICATIONS,
  MODULE_PREFIX_USER,
  MODULE_PREFIX_ASSETS,
} from "@/store";
import { GET_NOTIFICATION, GET_ASSETS_SELECTED } from "@/store/actions.type";
import { mapGetters } from "vuex";

import {
  NOTIFICATION_ASSET_RADIUS_MIN,
  NOTIFICATION_ASSET_RADIUS_MAX,
  NOTIFICATION_ASSET_RADIUS_DEFAULT,
  NOTIFICATION_ASSET_RADIUS_UNITS_DEFAULT,
} from "@/common/constants/notifications";

export default {
  name: "NotificationsAssets",
  components: {
    AssetsList: () => import("@/components/assetManagement/AssetsList"),
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    modal: false,
    selecting: null,
    radiusMin: NOTIFICATION_ASSET_RADIUS_MIN,
    radiusMax: NOTIFICATION_ASSET_RADIUS_MAX,
    selectedRadius: NOTIFICATION_ASSET_RADIUS_DEFAULT,
    selectedFilters: null,
  }),
  computed: {
    ...mapGetters({
      notification: MODULE_PREFIX_NOTIFICATIONS + "notification",
      preferences: MODULE_PREFIX_USER + "preferences",
      assetsSelected: MODULE_PREFIX_ASSETS + "assetsSelected",
    }),
    distanceUnits() {
      return this.preferences.poisDistUnits;
    },
    radiusLabel() {
      return `Radius around asset in ${this.distanceUnits}`;
    },
    notificationId() {
      if (this.notification?.formatted?.id) {
        return this.notification.formatted.id;
      }
      return null;
    },
  },
  mounted() {
    this.$store.dispatch(MODULE_PREFIX_ASSETS + GET_ASSETS_SELECTED, []);
  },
  methods: {
    openModal() {
      this.selecting = new Date().toISOString();
      this.modal = true;
    },
    closeModal() {
      this.modal = false;
    },
    handleClickCancel() {
      this.closeModal();
    },
    handleClickSelect() {
      const notification = lodashCloneDeep(this.notification);
      notification.formatted = notification.formatted || {};
      notification.formatted.params = notification.formatted.params || {};
      notification.formatted.params.managedAssets = this.assetsSelected;
      notification.formatted.params.assetRadius = this.selectedRadius;
      notification.formatted.params.assetRadiusUnits = this.getRadiusUnits();
      this.update(notification);
      this.closeModal();
    },
    handleOnEndRadius() {
      const notification = lodashCloneDeep(this.notification);
      notification.formatted = notification.formatted || {};
      notification.formatted.params = notification.formatted.params || {};
      notification.formatted.params.assetRadius = this.selectedRadius;
      notification.formatted.params.assetRadiusUnits = this.getRadiusUnits();
      this.update(notification);
    },
    handleChangeFilter(filters) {
      const notification = lodashCloneDeep(this.notification);
      notification.formatted = notification.formatted || {};
      notification.formatted.params = notification.formatted.params || {};
      notification.formatted.params.filters = filters;
      this.update(notification);
    },
    getRadiusUnits() {
      let units = NOTIFICATION_ASSET_RADIUS_UNITS_DEFAULT;
      if (
        this.preferences?.poisDistUnits &&
        this.preferences.poisDistUnits === "kilometers"
      ) {
        units = "km";
      }
      return units;
    },
    update(notification) {
      this.$store.dispatch(
        MODULE_PREFIX_NOTIFICATIONS + GET_NOTIFICATION,
        notification
      );
    },
  },
  watch: {
    notification: {
      handler() {
        if (lodashGet(this.notification, "formatted.params.assetRadius")) {
          this.selectedRadius = this.notification.formatted.params.assetRadius;
        } else {
          this.handleOnEndRadius();
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.asset-radius .label {
  font-size: 16px;
}
.assets-container {
  font-size: 16px;
  color: #00000099;
}
</style>
